import * as jwtUtils from '../jwt';

export const enum AppMarketQueryRoutes {
  TEST_APP = 'testApp',
  MANAGE_APPS = 'manageApps',
}

interface AppMarketJWTData {
  appDefId: string;
  version: string;
  shouldEditorInstall?: boolean;
  route?: AppMarketQueryRoutes;
}

export const parseAppMarketQueryParam = (
  jwt: string,
): AppMarketJWTData | null => {
  try {
    const jwtPayload = jwtUtils.parseJwt<{ data?: string }>(jwt);
    const parsedData = jwtPayload?.data && JSON.parse(jwtPayload.data);

    return {
      appDefId: parsedData.appDefId || parsedData.appId,
      version: parsedData.version,
      shouldEditorInstall: parsedData.shouldEditorInstall,
      route: parsedData.route,
    };
  } catch (e) {
    return null;
  }
};
